import * as PIXI from "pixi.js";
import { UIColors } from "../Settings/UITheme.js";
import { BarHeader } from "./ScrollableBarHeader.js";
export class ScrollableBar extends PIXI.Container {
    constructor(headerContainer, timeline) {
        super();
        this._graphics = new PIXI.Graphics();
        this.addChild(this._graphics);
        this._header = new BarHeader(timeline);
        headerContainer.addChild(this._header);
    }
    get leftBound() {
        return this.x;
    }
    get rightBound() {
        return this.x + this.width;
    }
    get barNumber() {
        return this._barNumber;
    }
    get numberOfBeats() {
        return this._numberOfBeats;
    }
    get verticalScrollPosition() {
        return this._verticalScrollPosition;
    }
    set verticalScrollPosition(value) {
        this._verticalScrollPosition = value;
        this._graphics.y = this._verticalScrollPosition;
    }
    resize(height) {
        this._graphics.clear();
        this._graphics.beginFill(UIColors.fgColor);
        this._graphics.drawRect(1, 0, 2, height);
        for (let i = 1; i < this._numberOfBeats + 1; i++) {
            this._graphics.drawRect(this._beatWidth * i, 0, 1, height);
        }
        this._graphics.endFill();
    }
    setX(value) {
        this.x = value;
        this._header.setX(value);
    }
    initialise(x, height, barNumber, numberOfBeats, beatWidth, metadataEventPosition, metadataEventActive, leftSide = true) {
        if (leftSide) {
            this.x = x;
        }
        else {
            this.x = x - beatWidth * numberOfBeats;
        }
        this._barNumber = barNumber;
        this._numberOfBeats = numberOfBeats;
        this._beatWidth = beatWidth;
        this.resize(height);
        this._header.initialise(this.x, numberOfBeats * this._beatWidth, this.barNumber, metadataEventPosition, metadataEventActive);
        return this;
    }
    setVisible(value) {
        this.visible = value;
        this._header.visible = value;
    }
}
//# sourceMappingURL=ScrollableBar.js.map